// Copyright (c) 2017 Deere & Company

const hasFeatureAccess = (securityModule, feature) => securityModule.features.find(item => item.feature === feature) ?
    securityModule.isAllowed && securityModule.features.find(item => item.feature === feature).isAllowed :
    securityModule.isAllowed;

export const hasAccess = (security, module, feature) => {

    let returnValue;

    returnValue = false;

    const securityModule = security.modules.find(item => item.module === module);

    if (securityModule) {

        returnValue = feature ? hasFeatureAccess(securityModule, feature) : securityModule.isAllowed;

    }

    return returnValue;

};



// WEBPACK FOOTER //
// ./src/shared/services/security.js